import { useTheme } from '@emotion/react';
import { Box, Typography } from '@mui/material';

const SubHeading = ({ heading }) => {
  const theme = useTheme();
  return (
    <Box sx={{ width: 'max-content', p: 1 }}>
      <Typography
        component='h4'
        fontWeight={'bold'}
        sx={{
          zIndex: 1,
          position: 'relative',
          fontSize: { xs: '1.5rem', xl: '1.75rem' },
        }}
      >
        {heading}
        <Box
          sx={{
            backgroundColor: '#fcaa0f',
            position: 'absolute',
            top: '-2%',
            width: { xs: '20px', xl: '25px' },
            height: { xs: '20px', xl: '25px' },
            left: '-3%',
            zIndex: -1,
          }}
        ></Box>
      </Typography>
    </Box>
  );
};

export default SubHeading;
